import { useState, useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
import useCaretPosition from "use-caret-position";
import { Box, Button, Popover } from "@mui/material";

const emptyObj = {
  firstPart: "",
  lastPart: "",
  selectionStart: 0,
};

function filterData({ allFields, search }) {
  return allFields?.filter((el) => {
    const item = el?.display_label;
    return item.toLowerCase().includes(search.toLowerCase());
  });
}

export function CustomTextfield2({ Controller, control, label, allFields, onChangeText, entity }) {
  const textFieldRef = useRef();
  const popoverTextFieldRef = useRef(null);
  const { x, y, getPosition, getSelection } = useCaretPosition(textFieldRef);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [splitTex, setSplitText] = useState(emptyObj);

  return (
    <>
      <Controller
        name="title"
        control={control}
        render={({ field }) => {
          const { onChange, ...rest } = field;
          return (
            <TextField
              {...rest}
              onChange={(e) => {
                const { value, selectionStart } = e.target;
                const caretPos = selectionStart - 1;
                const pressedCh = value.charAt(caretPos);
                if (pressedCh === "#") {
                  const firstPart = value.slice(0, caretPos);
                  const lastPart = value.slice(selectionStart, value.length);
                  setSplitText({ firstPart, lastPart, selectionStart });
                  requestAnimationFrame(() => {
                    textFieldRef.current.setSelectionRange(caretPos, caretPos);
                  });
                  return;
                }
                onChange(e);
              }}
              required
              sx={{ width: "100%" }}
              placeholder={label}
              id="title-input"
              variant="standard"
              size="small"
              multiline
              inputRef={textFieldRef}
              onKeyDown={(e) => {
                if (e.key === "#" && allFields?.length > 0) {
                  setOpen(true);
                  getPosition(textFieldRef);
                  return;
                }
                if (open) {
                  setOpen(false);
                }
              }}
            />
          );
        }}
      />

      <Popover
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        slotProps={{
          transition: {
            onEntered: () => {
              if (open && popoverTextFieldRef.current) {
                setTimeout(() => {
                  popoverTextFieldRef.current.focus();
                }, 0);
              }
            },
          },
        }}
        anchorReference="anchorPosition"
        anchorPosition={{ top: y + 20, left: x + 5 }}
        disableAutoFocus
        sx={{ p: ".25em" }}
      >
        <TextField
          sx={{ py: "6px", px: "8px" }}
          inputRef={popoverTextFieldRef}
          size="small"
          variant="standard"
          fullWidth
          placeholder="Search Field"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Box
          component="ul"
          sx={{
            maxWidth: "30rem",
            maxHeight: 300,
            overflowY: "auto",
            margin: 0,
            p: 0,
          }}
        >
          {filterData({ allFields, search })?.map((field) => {
            const buttonText = field?.display_label;
            const item = `${entity}.${field?.api_name}`;
            return (
              <li
                key={item}
                style={{
                  listStyle: "none",
                  overflow: "hidden",
                }}
              >
                <Button
                  sx={{
                    textTransform: "capitalize",
                    justifyContent: "flex-start",
                  }}
                  onClick={() => {
                    const withBracket = `\${${item}}`;
                    const newStr = `${splitTex.firstPart}${withBracket}${splitTex.lastPart}`;
                    onChangeText(newStr);
                    const caretPos = splitTex.firstPart.length + withBracket.length;
                    requestAnimationFrame(() => {
                      textFieldRef.current.setSelectionRange(caretPos, caretPos);
                    });
                    setSplitText(emptyObj);
                    setOpen(false);
                  }}
                >
                  {buttonText}
                </Button>
              </li>
            );
          })}
        </Box>
      </Popover>
    </>
  );
}
